const preload = urls => {
  urls.forEach(url => {
    new Image().src = url;
  });
};

export default preload;



// WEBPACK FOOTER //
// ./src/utilities/preloader.js